import { usePreferencesStore } from "../../stores/preferencesStore";

const LOCALES = [
  { value: "en", label: "English" },
  { value: "ar", label: "العربية" },
  { value: "bn", label: "বাংলা" },
  { value: "cs", label: "Čeština" },
  { value: "da", label: "Dansk" },
  { value: "de", label: "Deutsch" },
  { value: "de-DE", label: "Deutsch (DE)" },
  { value: "el", label: "Ελληνικά" },
  { value: "es", label: "Español" },
  { value: "fi", label: "Suomi" },
  { value: "fr", label: "Français" },
  { value: "he", label: "עברית" },
  { value: "hi", label: "हिन्दी" },
  { value: "id", label: "Bahasa Indonesia" },
  { value: "it", label: "Italiano" },
  { value: "ja", label: "日本語" },
  { value: "ko", label: "한국어" },
  { value: "nb", label: "Norsk bokmål" },
  { value: "nl", label: "Nederlands" },
  { value: "pl", label: "Polski" },
  { value: "pt", label: "Português" },
  { value: "ru", label: "Русский" },
  { value: "sv", label: "Svenska" },
  { value: "th", label: "ไทย" },
  { value: "tr", label: "Türkçe" },
  { value: "uk", label: "Українська" },
  { value: "vi", label: "Tiếng Việt" },
  { value: "zh-Hans", label: "中文（简体）" },
];

const DAYS = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];

export function CalendarSection() {
  const locale = usePreferencesStore((s) => s.locale);
  const firstDayOfWeek = usePreferencesStore((s) => s.firstDayOfWeek);
  const yearDrillTarget = usePreferencesStore((s) => s.yearDrillTarget);
  const yearDensityMode = usePreferencesStore((s) => s.yearDensityMode);
  const weekDayCount = usePreferencesStore((s) => s.weekDayCount);
  const setPref = usePreferencesStore((s) => s.setPreference);

  return (
    <div className="settings-section">
      <p className="settings-eyebrow">Calendar</p>
      <p className="settings-desc">Configure calendar display</p>

      <div className="form-group">
        <label className="label" htmlFor="pref-locale">Locale</label>
        <select
          id="pref-locale"
          className="input"
          value={locale}
          onChange={(e) => setPref("locale", e.target.value)}
        >
          {LOCALES.map((l) => (
            <option key={l.value} value={l.value}>{l.label}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="label" htmlFor="pref-fdow">First day of week</label>
        <select
          id="pref-fdow"
          className="input"
          value={firstDayOfWeek}
          onChange={(e) => setPref("firstDayOfWeek", Number(e.target.value))}
        >
          {DAYS.map((d) => (
            <option key={d.value} value={d.value}>{d.label}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label className="label" htmlFor="pref-ydt">Year view drill target</label>
        <select
          id="pref-ydt"
          className="input"
          value={yearDrillTarget}
          onChange={(e) => setPref("yearDrillTarget", e.target.value as "day" | "month")}
        >
          <option value="month">Month</option>
          <option value="day">Day</option>
        </select>
      </div>

      <div className="form-group">
        <label className="label" htmlFor="pref-ydm">Year view density</label>
        <select
          id="pref-ydm"
          className="input"
          value={yearDensityMode}
          onChange={(e) => setPref("yearDensityMode", e.target.value as "dot" | "heatmap" | "count")}
        >
          <option value="dot">Dots</option>
          <option value="heatmap">Heatmap</option>
          <option value="count">Count</option>
        </select>
      </div>

      <div className="form-group">
        <label className="label" htmlFor="pref-wdc">Week day count</label>
        <select
          id="pref-wdc"
          className="input"
          value={weekDayCount}
          onChange={(e) => setPref("weekDayCount", Number(e.target.value))}
        >
          {[2, 3, 4, 5, 6, 7].map((n) => (
            <option key={n} value={n}>{n} days</option>
          ))}
        </select>
      </div>
    </div>
  );
}
